import { Notify } from "quasar";

export function notifyError(options: {
  message: string;
  icon?: string;
  timeout?: number;
  retryLabel?: string;
  onRetry?: () => void;
}) {
  Notify.create({
    type: "negative",
    message: options.message,
    icon: options.icon,
    timeout: options.timeout,
    actions: [
      options.onRetry
        ? {
            label: options.retryLabel || "Retry",
            handler: options.onRetry,
            color: "white",
          }
        : null,
      {
        icon: "close",
        color: "white",
        round: true,
        handler: () => {
          /* ... */
        },
      },
    ].filter((a) => a !== null),
  });
}

export function notifyWarning(options: {
  message: string;
  icon?: string;
  timeout?: number;
}) {
  Notify.create({
    type: "warning",
    textColor: "black",
    timeout: options.timeout,
    message: options.message,
    icon: options.icon,
    actions: [
      {
        icon: "close",
        color: "black",
        round: true,
        handler: () => {
          /* ... */
        },
      },
    ],
  });
}

export function notifySuccess(options: {
  message: string;
  icon?: string;
  timeout?: number;
}) {
  Notify.create({
    type: "positive",
    textColor: "black",
    message: options.message,
    icon: options.icon,
    timeout: options.timeout,
    actions: [
      {
        icon: "close",
        color: "black",
        round: true,
        handler: () => {
          /* ... */
        },
      },
    ],
  });
}
